<app-header></app-header>

<!-- <app-homepage-slider> </app-homepage-slider> -->

<header class="slidermain home-page text-white">
    <div id="mainSlider" class="owl-carousel owlExample">

        <div class="item" id="bookmark{{i+1}}" *ngFor="let slide of homePageSliderList; let i=index;">
            <img [src]="imgurl+slide.picture" alt="news" class="img-fluid w-100 h-100">
            <div class="fade-bg"></div>
            <div class="container-fluid">
                <div class="mask-content-v-center text-center">
                    <div class="heading{{i+1}}">
                        <!-- <h1>{{ 'HOME.sajway' | translate }}</h1> -->
                        <h1 *ngIf="showLang == 'en' ">{{slide.bigCaption}}</h1>
                        <h1 *ngIf="showLang == 'ar' ">{{slide.bigCaption_ar}}</h1>
                       
                        <p *ngIf="showLang == 'en' ">{{slide.smallCaption}}</p>
                        <p *ngIf="showLang == 'ar' ">{{slide.smallCaption_ar}}</p>
                       
                    </div>
                </div>
            </div>
        </div>



    </div>

    <div class="container text-center">
        <a class="btn-scroll js-scroll-trigger" (click)="scrollToElement(howWework)"> <i
                class="fas fa-angle-double-down"></i> </a>
    </div>

    <div class="bookmarks bannernavs">
        <ul class="test">
            <li class="bookmark{{i+1}}" [attr.data]="i+1" *ngFor="let s of  homePageSliderList; let i=index;">
                <p>0{{i+1}} </p>
            </li>
            <!-- <li class="bookmark2" data="2">
                <p>02</p>
            </li>
            <li class="bookmark3" data="3">
                <p>03</p>
            </li>
            <li class="bookmark4" data="4">
                <p>04</p>
            </li>
            <li class="bookmark5" data="5">
                <p>05</p>
            </li>
            <li class="bookmark6" data="6">
                <p>06</p>
            </li>
            <li class="bookmark7" data="7">
                <p>07</p>
            </li> -->
        </ul>
    </div>


    <div class="social-icons">
        <a target="_blank" href="https://www.facebook.com/SajWay/"><i class="fab fa-facebook-f"></i></a>
        <a target="_blank" href="https://www.youtube.com/channel/UCo3eP11Z9NKFTyl8j00pgDg"><i
                class="fab fa-youtube"></i></a>
    </div>
</header>

<!-- <header class="slidermain text-white">
    <div id="mainBanner" class="owl-carousel owl-theme"> -->

<!-- banner  item -- loop start-->

<!-- <div class="item" id="{{i+1}}" *ngFor="let data of homePageSliderList; let i=index">
            <img src="{{imgurl}}{{data.picture}}" alt="news" class="w-100">
            <div class="fade-bg"></div>
            <div class="container-fluid" style="position: absolute;top:10%">
                <div class="mask-content-v-center text-center">
                    <h1>{{data.bigCaption }}</h1>
                    <p class="d-none d-md-block">
                        <span>{{ data.smallCaption }}</span> <br> 
                    </p>
                </div>
            </div>
        </div> -->

<!---Loop end here--->
<!-- banner  item -->
<!-- <div class="item" data-hash="02">
            <img src="assets/img/2nd-banner-img.jpg" alt="news" class="w-100">
              <div class="fade-bg"></div>
            <div class="container-fluid">
                <div class="mask-content-v-center text-center">
                    <h1 class="heading2">Mouth watering delicacies</h1>
                   
                </div>
            </div>             
        </div> -->

<!-- banner  item -->
<!-- <div class="item" data-hash="03">
            <img src="assets/img/3rd-banner-img.jpg" alt="news" class="w-100">
            <div class="fade-bg"></div>
            <div class="container-fluid">
                <div class="mask-content-v-center text-center">
                   <div class="heading3">
                        <h1>Sajway</h1>
                       <p class="d-none d-md-block">
                          Authentically flavored cuisine
                       </p>
                   </div>
                </div>
            </div>
        </div> -->

<!-- </div>
    <div class="container text-center">
        <a class="btn-scroll js-scroll-trigger" (click)="scrollToElement(howWework)"> <i class="fas fa-angle-double-down"></i> </a>
    </div>
    <div class="bannernavs">
        <a class="button secondary url" href="#1">01</a>
        <a class="button secondary url" href="#2">02</a>
        <a class="button secondary url" href="#3">03</a>
    </div>
    <div class="social-icons">
        <a target="_blank" href="https://www.facebook.com/SajWay/"><i class="fab fa-facebook-f"></i></a>
        <a target="_blank" href="https://www.youtube.com/channel/UCo3eP11Z9NKFTyl8j00pgDg"><i class="fab fa-youtube"></i></a>
    </div>
</header> -->

<section id="howWework" class="howework py-4" #howWework>

    <div class="container-fluid">
        <div class="row heading">
            <div class="col-md-12">
                <h2>{{ 'HOME.Home_c4' | translate }}</h2> 
            </div>
        </div>

        <div class="col-md-12">
            <div class="row mr0">
                <div class="col-lg-4 col-sm-12 profile-cols animate" data-anim-type="zoomIn" data-anim-delay="100"
                    *ngFor="let data of homepageBestSeelerList">
                    <div class="card">
                        <a href="{{data.picturl}}">
                            <img src="{{imgurl}}{{data.picture}}" class="img-fluid w-100" alt="Em Bassam Food">
                            <div class="card-body">
                                
                                <h3 *ngIf="showLang == 'en' ">{{data.smallCaption}}</h3>
                                <h3 *ngIf="showLang == 'ar' ">{{data.smallCaption_ar}}</h3>
                                <hr>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>